import { useContext } from 'react';
import { AbilityContext  } from '../context/ability-provider';

const useAppAbility = () => useContext(AbilityContext);

export default useAppAbility;
